import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import './PrivacyPage.css';

const PrivacyPage: React.FC = () => {
  // Scroll to top on component mount
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="privacy-page">
      <PageHeader 
        title="Privacy Policy" 
        date={`Last updated: ${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}`} 
      />

      <div className="container privacy-content">
        <section className="privacy-section">
          <h2>Introduction</h2>
          <p>
            At The Caffeinated Crumb, we respect your privacy and are committed to protecting your personal data. 
            This privacy policy explains how we collect, use, and safeguard your information when you visit our website 
            or use our services.
          </p>
          <p>
            We do not collect personal information unless you voluntarily provide it through our contact form or 
            newsletter subscription. We use this information solely for the purpose of responding to your inquiries
            or sending you updates about our products and services.
          </p>
        </section>
        
        <section className="privacy-section">
          <h2>Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, email address, and any other information you provide 
              when using our contact form or subscribing to our newsletter.
            </li>
            <li>
              <strong>Usage Data:</strong> Information about how you use our website, including your browser type, 
              IP address, pages visited, and time spent on our site.
            </li>
            <li>
              <strong>Cookies and Tracking Technologies:</strong> We use cookies to enhance your browsing experience 
              and analyze website traffic.
            </li>
          </ul>
        </section>
        
        <section className="privacy-section">
          <h2>How We Use Your Information</h2>
          <p>We use your information for the following purposes:</p>
          <ul>
            <li>To respond to your inquiries and provide customer support</li>
            <li>To send newsletters and marketing communications if you've subscribed</li>
            <li>To improve our website and services based on usage data</li>
            <li>To protect our website and users from fraudulent or harmful activities</li>
          </ul>
        </section>
        
        <section className="privacy-section">
          <h2>Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information from unauthorized access, 
            alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure, 
            so we cannot guarantee absolute security.
          </p>
        </section>
        
        <section className="privacy-section">
          <h2>Third-Party Services</h2>
          <p>
            We may use third-party services (such as Formspark for form submissions and newsletter services) to process 
            your information. These services have their own privacy policies, and we recommend reviewing them.
          </p>
        </section>
        
        <section className="privacy-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access, correct, or delete your personal information</li>
            <li>Withdraw consent at any time for data processing</li>
            <li>Object to the processing of your personal data</li>
            <li>Request data portability</li>
          </ul>
          <p>
            To exercise these rights, please contact us through our <Link to="/contact">Contact Form</Link>.
          </p>
        </section>
        
        <section className="privacy-section">
          <h2>Children's Privacy</h2>
          <p>
            Our website is not intended for children under 13 years of age. We do not knowingly collect personal 
            information from children under 13.
          </p>
        </section>
        
        <section className="privacy-section">
          <h2>Changes to This Privacy Policy</h2>
          <p>
            We may update this privacy policy from time to time. The most current version will always be posted on 
            this page with the effective date.
          </p>
        </section>
        
        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions or concerns about our privacy policy, please contact us through our 
            <Link to="/contact"> Contact Form</Link>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPage;
